/* eslint-disable import/no-extraneous-dependencies */
// eslint-disable-next-line import/no-namespace
import * as __linariaReact from '../../../../../node_modules/@linaria/react';

// eslint-disable-next-line no-console
console.log(`>>>>>>>> linaria react`, __linariaReact);

const linaria =
  'default' in __linariaReact ? __linariaReact.default : __linariaReact;

export const styled = (linaria as any).styled;
